import * as React from 'react';

import {Button} from '../button/button';
import {SaveButton} from '../button/save-button/save-button';
import type {ButtonVariant} from '../button/types';
// @ts-expect-error
import {LoadingIcon} from '../icon/svg/loading-icon';
import {Body} from '../typography/body';

import {FooterBar} from './footer-bar';
import {Modal} from './modal';

import styles from './two-pane-modal-form.module.css';

type Props = {
    rightSection: React.ReactNode;
    leftSection: React.ReactNode;
    rightPaneWidth?: number;
    headerText: string;
    submitButtonText: string;
    saveButtonVariant?: ButtonVariant;
    errorMessage?: string | null | undefined;
    saveButtonDisabled?: boolean;
    isSaving?: boolean;
    isLoading?: boolean;
    onSubmit: () => void;
    onClose: () => void;
    customErrorComponent?: React.ReactNode;
    footerLeftItem?: React.ReactNode;
};

export function TwoPaneModalForm(props: Props) {
    const {
        rightSection,
        leftSection,
        onSubmit,
        onClose,
        submitButtonText,
        errorMessage,
        isSaving,
        saveButtonDisabled,
        isLoading,
        ...restProps
    } = props;

    return (
        <Modal {...restProps} onClose={onClose}>
            {isLoading ? (
                <div className='absolutely-center-and-fill'>
                    <LoadingIcon />
                </div>
            ) : (
                <>
                    <form onSubmit={onSubmit} className={styles['two-pane-modal-form-container']}>
                        <div className={styles['left-section']}>{leftSection}</div>
                        <div className='flex-grow'>{rightSection}</div>
                    </form>
                    <FooterBar
                        absolutePosition={true}
                        left={
                            props.footerLeftItem ? (
                                props.footerLeftItem
                            ) : (
                                <Button
                                    variant='text-secondary'
                                    noPadding={true}
                                    size='big'
                                    onClick={onClose}
                                >
                                    Cancel
                                </Button>
                            )
                        }
                        right={
                            <div className='flex gap-16 align-center'>
                                {props.customErrorComponent ? (
                                    props.customErrorComponent
                                ) : (
                                    <div className={styles['error-message']}>
                                        {errorMessage && <Body color='error'>{errorMessage}</Body>}
                                    </div>
                                )}
                                <SaveButton
                                    size='big'
                                    variant={props.saveButtonVariant || 'primary'}
                                    // @ts-expect-error
                                    onClick={onSubmit}
                                    errorSaving={Boolean(errorMessage)}
                                    isSaving={isSaving || false}
                                    disabled={saveButtonDisabled}
                                    buttonText={submitButtonText}
                                />
                            </div>
                        }
                    />
                </>
            )}
        </Modal>
    );
}
